export default "__VITE_PUBLIC_ASSET__545b881b__"